<template>
    <v-container fluid>
        <v-row>
            <v-col 
                style="display: flex; align-content: center; align-items: center;"
                cols="7"
                lg="10"
                md="10"
                sm="6"
            >
                <h3>Completed Jobs</h3>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-form @submit.prevent="getRegisters">
                    <v-text-field
                        v-model="filter.fastSearch"
                        label="Quick Search"
                        prepend-inner-icon="mdi mdi-magnify"
                        outlined
                        single-line
                        @click:prepend-inner="getRegisters"
                        dense
                    ></v-text-field>
                </v-form>
            </v-col>
        </v-row>
        <v-row>
            <v-col 
                cols="12"
                lg="4"
                md="4"
                sm="12"
            >
                <label>Job Status</label>
                <v-combobox
                    v-model="filter.completionStatusSelected"
                    :items="listCompletionStatus" 
                    item-text="description"
                    item-value="id"
                    clearable
                    outlined
                    dense
                    @change="filterRegisters()"
                ></v-combobox>
            </v-col>
            <v-col 
                cols="12"
                lg="4"
                md="4"
                sm="12"
            >
                <label>Customer Source</label>
                <v-combobox
                    v-model="filter.customerOriginSelected"
                    :items="listCustomerOrigin" 
                    item-text="description"
                    item-value="id"
                    clearable
                    outlined
                    dense
                    @change="filterRegisters()"
                ></v-combobox>
            </v-col>
            <v-col 
                cols="12"
                lg="4"
                md="4"
                sm="12"
            >
                <label>Sales Person</label>
                <v-combobox
                    v-model="filter.sellerSelected"
                    :items="listSellers" 
                    item-text="name"
                    item-value="id"
                    clearable
                    outlined
                    dense
                    @change="filterRegisters()"
                ></v-combobox>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-data-table
                    :headers="headers"
                    :items="filteredSearch"
                    :options.sync="options"
                    :loading="loading"
                    :items-per-page="10"
                    no-data-text="No Record Found"
                >
                    <template v-slot:item.idService="{ item }">
                        <v-tooltip left>
                            <template v-slot:activator="{ on }">
                                <a @click="goToServiceDetails(item.idService)" v-on="on" target="_blank">
                                    {{ item.idService }}
                                </a>
                            </template>
                            <span>Job Details</span>
                        </v-tooltip>
                    </template>

                    <template v-slot:item.statusDescription="{ item }">
                        <v-chip
                            :color="getStatusColor(item.status)"
                            outlined
                            dark
                        >
                            {{ item.statusDescription }}
                        </v-chip>
                    </template>

                    <template v-slot:item.completionStatus="{ item }">
                        <v-chip
                            :color="getCompletionStatusColor(item.completionStatus)"
                            outlined
                            dark
                            small
                        >
                            {{ item.completionStatus }}
                        </v-chip>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>

    </v-container>
</template>

<script>
    import { mapGetters } from 'vuex';
    import Helpers from '@/utilities/Helpers';
    export default ({

        mixins: [Helpers],

        data: () => ({

            loading: false,

            filter: {
                fastSearch: '',
                customerOriginSelected: null,
                sellerSelected: null,
                completionStatusSelected: null
            },

            headers: [
                { text: "ID", value: "idService", sortable: true, size: "5%" },
                { text: "Customer", value: "customerName", sortable: true },
                { text: "Address", value: "projectAddress", sortable: true },
                { text: "Type", value: "typeProject", sortable: true },
                { text: "Customer Source", value: "customerOriginDescription", sortable: true },
                { text: "Sales Person", value: "userNameResponsible", sortable: true },
                { text: "Phase", value: "statusDescription", sortable: true },
                { text: "Job Status", value: "completionStatus", sortable: true },
                { text: "Close Reason", value: "closeJobReason", sortable: true }
            ],

            options: { rowsPerPage: 10, page: 1 },

            listService: [],
            listServiceFiltered: [],

            listCustomerOrigin: [],
            listSellers: [],

            listCompletionStatus: [
                { id: 'Closed', description: 'Closed' },
                { id: 'Completed', description: 'Completed' },
                { id: 'Withdrawal', description: 'Withdrawal' },
                { id: 'Canceled', description: 'Canceled' }
            ],
        }),

        computed: {
            ...mapGetters('logInModule', { userLoggedGetters: 'searchState' }),

            filteredSearch: function() {
                return this.listServiceFiltered.filter((serviceFilter) => {
                    
                    const filter = this.filter.fastSearch.toLowerCase();

                    const customerName = serviceFilter.customerName != null && serviceFilter.customerName != undefined ? serviceFilter.customerName.toLowerCase().match(filter): ""
                    const customerOriginDescription = serviceFilter.customerOriginDescription != null && serviceFilter.customerOriginDescription != undefined ? serviceFilter.customerOriginDescription.toLowerCase().match(filter): ""
                    const userNameResponsible = serviceFilter.userNameResponsible != null && serviceFilter.userNameResponsible != undefined ? serviceFilter.userNameResponsible.toLowerCase().match(filter) : ""
                    const closeJobReason = serviceFilter.closeJobReason != null && serviceFilter.closeJobReason != undefined ? serviceFilter.closeJobReason.toLowerCase().match(filter) : ""
                    const completionStatus = serviceFilter.completionStatus != null && serviceFilter.completionStatus != undefined ? serviceFilter.completionStatus.toLowerCase().match(filter) : ""
                    const id = serviceFilter.id.toString().match(filter);

                    if (customerName != null) { return customerName; } 
                    else if(customerOriginDescription != null) { return customerOriginDescription; } 
                    else if(userNameResponsible != null) { return userNameResponsible; }
                    else if(closeJobReason != null) { return closeJobReason; }
                    else if(completionStatus != null) { return completionStatus; }
                    else { return id; }
                });
            }
        },

        methods: {
            goToServiceDetails(id) {
                this.$router.push({ name: "serviceDetails", params: {id: id} });
            },

            getStatusColor (status) {

                let color = "";

                switch (status) {

                    case 0:
                        color = 'var(--color__silver)';
                        break;

                    case 1:
                        color = 'var(--color__red)';
                        break;

                    case 2:
                        color = 'var(--color__main)';
                        break;

                    case 3:
                        color = 'var(--color__status_pending)';
                        break;

                    case 4:
                        color = 'var(--color__completed)';
                        break;

                    case 5:
                        color = 'var(--color__completed)';
                        break;

                    default:
                        color = 'var(--color__main)';
                        break;
                }

                return color
            },

            getCompletionStatusColor(completionStatus) {
                switch (completionStatus) {
                    case 'Closed': return 'var(--color__main)';
                    case 'Completed': return 'var(--color__completed)';
                    case 'Withdrawal': return 'var(--color__alert)';
                    case 'Canceled': return 'var(--color__red)';
                    default: return 'var(--color__silver)';
                }
            },

            async assignSalesPerson() {

                this.showLoading();

                this.getRegisters();

                this.hideLoading();
            },

            async getRegisters() {

                this.showLoading();

                this.listService = await this.$store.dispatch("serviceModule/ListCompletedJobs");
                console.log('this.listService', this.listService);
                this.listServiceFiltered = [...this.listService];
                this.listCustomerOrigin = await this.$store.dispatch("customerOriginModule/List");
                this.listSellers = await this.$store.dispatch("userModule/ListSalesPerson");
                this.filterRegisters();

                this.hideLoading();
            },

            async filterRegisters() {

                let idCustomerOrigin = 0;
                let idSeller = 0;
                let listFiltered = [...this.listService];

                if (this.filter.completionStatusSelected != null && this.filter.completionStatusSelected != undefined) {
                    const completionStatus = this.filter.completionStatusSelected.id;
                    listFiltered = listFiltered.filter(ser => ser.completionStatus == completionStatus);
                }

                if (this.filter.customerOriginSelected != null && this.filter.customerOriginSelected != undefined) {
                    idCustomerOrigin = this.filter.customerOriginSelected.id;
                    listFiltered = listFiltered.filter(ser => ser.idCustomerOrigin == idCustomerOrigin);
                }

                if (this.filter.sellerSelected != null && this.filter.sellerSelected != undefined) {
                    idSeller = this.filter.sellerSelected.id;
                    listFiltered = listFiltered.filter(ser => ser.idUserResponsible == idSeller);
                }

                this.listServiceFiltered = listFiltered;
            }
        },

        async created() {
            await this.getRegisters();
        }
    })
</script>
